// 模块账户
import styles from './index.module.less'
import Title from '@/components/BlockTitleTwo'
import icon from '@/assets/image/gea/verifynodes.svg'
import SearchInput from '@/components/SearchInputTwo'
import BlockTitle from '@/components/BockTitle'
import ModuleAccountDetailCard from '../components/moduleAccountDetailCard'
import CoduleAccountTrading from '../components/coduleAccountTrading/index'
import { useTranslation } from 'react-i18next'
import { useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getModuleAccountTxList, getModuleAccountDetail } from '@/api/moduleAccount'
import { useRequest } from 'ahooks'
import { ugagToGag, ugeaToGea2 } from '@/utils/number'
import type { IResModuleTxListItemType, IAccountDetail } from '@/api/moduleAccount/interface.ts'
import LoadingCom from '@/components/LoadingCom'
import MeEmpty from '@/components/MeEmpty'
import useMeNavigate from '@/hooks/useMeNavigate'
import MePaginationNew from '@/components/MePaginationNew'
import SlideBtn, { IbtnListItem } from '@/components/SlideBtn'

const ModuleAccount = () => {
  const { address } = useParams()
  const { t } = useTranslation()
  const navigate = useMeNavigate()
  const [tabList, setTabList] = useState<IbtnListItem[]>([
    {
      name: 'GEA HUB', // hub
      value: 'hub',
      active: true,
    },
    {
      name: 'Rollapp Check-in', // rollup
      value: 'rollup',
      active: false,
    },
  ])
  const [pageParams, setPageParams] = useState({
    offset: 0,
    limit: 10,
    page: 1,
  })

  const [accountDetail, setAccountDetail] = useState<IAccountDetail>({} as IAccountDetail)
  useRequest(() => getModuleAccountDetail(address!), {
    refreshDeps: [address],
    ready: !!address,
    onSuccess: (res) => {
      if (!res?.isModuleAccount) {
        navigate(`/accountDetail/${res.address}`, { replace: true })
        return
      }
      setAccountDetail({
        name: res.name || '-',
        description: res.description || '-',
        regionId: res?.regionId?.toUpperCase() || '-',
        geaAmount: ugeaToGea2(res.UgeaAmount).value,
        sigin: ugeaToGea2(res.UgeaAmount).sigin,
        gagAmount: ugagToGag(res.UgagAmount).value,
        gagSigin: ugagToGag(res.UgagAmount).sigin,
        address: res.address,
      })
    },
  })

  const [total, setTotal] = useState<number>(0)
  const [txList, setTxList] = useState<IResModuleTxListItemType[]>([])

  // next key 链表
  const moduleTransactionKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  // next offset key 链表
  const moduleTransactionOffsetKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  // 下一组key
  const moduleTransactionNextKey = useRef('')
  const moduleTransactionOffsetKey = useRef('')
  const [moduleTransactionNextKeyData, setModuleTransactionNextKeyData] = useState<string>('')
  // 当前组索引
  const moduleTransactionCurrentGroupIndex = useRef(0)

  /**是否可以上一组下一组 */
  const transactionPaginationPreAndNext = useMemo(() => {
    return {
      canNext: !!moduleTransactionNextKeyData,
      canPrev: moduleTransactionCurrentGroupIndex.current > 0,
    }
  }, [moduleTransactionNextKeyData, moduleTransactionCurrentGroupIndex.current])

  /** 参数组装 */
  const getPageParams = () => {
    const params: any = {
      offset: pageParams.offset,
      limit: pageParams.limit,
      address,
    }
    if (moduleTransactionKeyArray.current[moduleTransactionCurrentGroupIndex.current]) {
      params.key = moduleTransactionKeyArray.current[moduleTransactionCurrentGroupIndex.current]
    }
    if (
      moduleTransactionOffsetKeyArray.current[moduleTransactionCurrentGroupIndex.current] &&
      pageParams.offset > 0
    ) {
      params.offset_key =
        moduleTransactionOffsetKeyArray.current[moduleTransactionCurrentGroupIndex.current]
    }
    return params
  }

  const curTab = useMemo(() => {
    return tabList.find((item) => item.active)?.value
  }, [tabList])

  const { loading: listLoading } = useRequest(() => getModuleAccountTxList(getPageParams()), {
    ready: false,
    refreshDeps: [
      pageParams.limit,
      pageParams.offset,
      address,
      moduleTransactionCurrentGroupIndex.current,
    ],
    onSuccess: (res) => {
      setTxList(res?.ModuleTransfer || [])
      setTotal(res?.group_count || 0)
      moduleTransactionNextKey.current = res.next_key || ''
      setModuleTransactionNextKeyData(res.next_key || '')
      moduleTransactionOffsetKeyArray.current[moduleTransactionCurrentGroupIndex.current] =
        res.offset_key || ''
      // 设置当前组offsetKey
      moduleTransactionOffsetKey.current = res.offset_key || ''
    },
  })

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        {/* icon={icon} */}
        <Title title={t('explorer_215')} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      {/* 详情 */}
      <div className={styles.BlockTitleWrap}>
        <BlockTitle title={t('explorer_152')}></BlockTitle>
        <div className={styles.accountDetail_warp}>
          {<ModuleAccountDetailCard accountDetail={accountDetail as IAccountDetail} />}
        </div>
      </div>
      {/* 交易 */}
      {/* <div>
        <div className="tab_page_wrap">
          <BlockTitle title={t('explorer_4')}></BlockTitle>
          <div className="gea_pagination_box">
            <MePaginationNew
              currentPage={pageParams.page}
              pageSize={pageParams.limit}
              setPageParams={setPageParams}
              loading={listLoading}
              total={curTab === 'hub' ? total : 0}
              paginationPreAndNext={transactionPaginationPreAndNext}
              prevKeyFn={() => {
                if (listLoading) return
                if (moduleTransactionCurrentGroupIndex.current === 0) return
                if (moduleTransactionCurrentGroupIndex.current > 0) {
                  moduleTransactionCurrentGroupIndex.current--
                }
                setPageParams({
                  offset: 0,
                  limit: pageParams.limit,
                  page: 1,
                })
              }}
              nextKeyFn={() => {
                if (listLoading) return
                if (!moduleTransactionNextKey.current) return
                moduleTransactionCurrentGroupIndex.current++
                moduleTransactionKeyArray.current[moduleTransactionCurrentGroupIndex.current] =
                  moduleTransactionNextKey.current
                moduleTransactionOffsetKeyArray.current[
                  moduleTransactionCurrentGroupIndex.current
                ] = moduleTransactionOffsetKey.current
                setPageParams({
                  offset: 0,
                  limit: pageParams.limit,
                  page: 1,
                })
              }}
            />
          </div>
        </div>
        <div className={styles.slideBtnWrap}>
          <SlideBtn btnList={tabList} setBtnList={setTabList}></SlideBtn>
        </div>
        {curTab === 'hub' ? (
          <>
            <div className="transaction_block">
              {listLoading && <LoadingCom />}
              {!listLoading && txList.length === 0 && <MeEmpty />}
              {txList.map((item: any, index: number) => (
                <CoduleAccountTrading {...item} key={`block${index}`} />
              ))}
            </div>
          </>
        ) : (
          <>
            <div className="transaction_block">
              <MeEmpty></MeEmpty>
            </div>
          </>
        )}

        <div className="footer_pagination_account">
          <MePaginationNew
            currentPage={pageParams.page}
            pageSize={pageParams.limit}
            setPageParams={setPageParams}
            loading={listLoading}
            total={curTab === 'hub' ? total : 0}
            paginationPreAndNext={transactionPaginationPreAndNext}
            prevKeyFn={() => {
              if (listLoading) return
              if (moduleTransactionCurrentGroupIndex.current === 0) return
              if (moduleTransactionCurrentGroupIndex.current > 0) {
                moduleTransactionCurrentGroupIndex.current--
              }
              setPageParams({
                offset: 0,
                limit: pageParams.limit,
                page: 1,
              })
            }}
            nextKeyFn={() => {
              if (listLoading) return
              if (!moduleTransactionNextKey.current) return
              moduleTransactionCurrentGroupIndex.current++
              moduleTransactionKeyArray.current[moduleTransactionCurrentGroupIndex.current] =
                moduleTransactionNextKey.current
              moduleTransactionOffsetKeyArray.current[moduleTransactionCurrentGroupIndex.current] =
                moduleTransactionOffsetKey.current
              setPageParams({
                offset: 0,
                limit: pageParams.limit,
                page: 1,
              })
            }}
          />
        </div>
      </div> */}
    </div>
  )
}
export default ModuleAccount
